export default __webpack_public_path__ + "static/media/download-circle-fill.d5f15611.svg";